import en from './en.json';
import de from './de.json';
import it from './it.json';
import id from './id.json';
import ro from './ro.json';
import ru from './ru.json';
import es from './es.json';
import nl from './nl.json';
import fr from './fr.json';
import zh from './zh.json';

import zh_tw from './zh_tw.json';

import pt_br from './pt_br.json';

import pt_pt from './pt_pt.json';
import pl from './pl.json';
import sv from './sv.json';
import el from './el.json';
import hu from './hu.json';
import da from './da.json';
import no from './no.json';
import fa from './fa.json';
import ua from './ua.json';
import tr from './tr.json';
import cz from './cz.json';
import ja from './ja.json';
import fi from './fi.json';
import ko from './ko.json';
import ky from './ky.json';

const pt = pt_pt;

export default {
  en,
  de,
  it,
  id,
  ro,
  ru,
  es,
  nl,
  fr,
  pt,

  pt_br,

  pt_pt,
  zh,

  zh_tw,
  pl,
  sv,
  el,
  hu,
  da,
  no,
  fa,
  ua,
  tr,
  cz,
  ja,
  fi,
  ko,
  ky,
};
